export interface OtherDeductionItem {
  id: number;
  amount: number;
  type: OtherDeductionItemType;
  createdAt?: Date;
  updatedAt?: Date;
  payslipId: number;
}

export enum OtherDeductionItemType {
  DEDUCTION = "DEDUCTION",
  ADVANCE = "ADVANCE",
  MEDICAL_CO_SHARE = "MEDICAL_CO_SHARE",
  NS_MAKEUP_PAY = "NS_MAKEUP_PAY",
  LOAN = "LOAN",
}

export const OtherDeductionItemTypeLabels: {
  [key in OtherDeductionItemType]: string;
} = {
  [OtherDeductionItemType.DEDUCTION]: "Deduction",
  [OtherDeductionItemType.ADVANCE]: "Advance",
  [OtherDeductionItemType.MEDICAL_CO_SHARE]: "Medical Co-Share",
  [OtherDeductionItemType.NS_MAKEUP_PAY]: "NS Makeup Pay",
  [OtherDeductionItemType.LOAN]: "Loan",
};
